import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import paginationValue from "../common/paginationValue.json";
import Pagination from "../components/Layout/Pagination";
import axios from "axios";
import AxiosInstance from "../utils/axiosInstance";
import toast from "react-hot-toast";
import loader from "../assets/loader.svg";
import searchIcon from "../assets/search-icon.svg";

import OptInModel from "../components/Model/OptInModel";
import ViewPlanHolderModel from "../components/Model/ViewPlanHolderModel";
import SeeRecordsModel from "../components/Model/SeeRecordsModel";
import AdvertiseForHelpModel from "../components/Model/AdvertiseForHelpModel";
import PrimeContractorHelpModel from "../components/Model/PrimeContractorHelpModel";
import { getFormattedDate, getLabelsFromWorktypes } from "../utils/helper";
import favoriteImg from "../assets/bookmark-favorite.svg";
import WorkTypeFilter from "../components/Filters/WorkTypeFilter";
import { getTimeAgo } from "../utils/helper";
import ProjectDetailsModel from "../components/Model/ProjectDetailsModel";
export default function StateCityCountryPage() {
  const [selectedType, setSelectedType] = useState({
    value: "All",
    label: "ALL",
  });
  const [currentPage, setCurrentPage] = useState(paginationValue.currentPage);
  const [resetTrue, setResetTrue] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageLimit, setPageLimit] = useState(paginationValue.limit);
  const [APICall, setAPICAll] = useState(false);
  const [selectedState, setSelectedState] = useState(
    JSON.parse(localStorage.getItem("selectedState")) || null,
  );
  const [showloader, setloader] = useState(false);
  const [List, setList] = useState([]);
  const abortControllerRef = useRef(null);
  const [modelDetailsOpen, setModelDetailsOpen] = useState(false); // New state
  const [modelOpen, setModelOpen] = useState(false);
  const [modelOpenViewPlan, setModdelOpenViewPlan] = useState(false);
  const [modelOpenOptIN, setModelOpenOptIN] = useState(false);
  const [modelSeeRecords, setModelSeeRecords] = useState(false);
  const [modelAdvertiseForHelp, setModelAdvertiseForHelp] = useState(false);
  const [PrimeContractorHelp, setModelPrimeContractorHelp] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [workTypeId, setWorkTypeId] = useState("");

  const [dashboardData, setDashboardData] = useState([]);
  const [isAddOnDashboard, setAddOnDashboard] = useState(0);
  const [isLoading, setIsLoading] = useState(false); // Add isLoading
  useEffect(() => {
    // Load the data from localStorage on component mount
    const savedDashboardData =
      JSON.parse(localStorage.getItem("add_to_dashboard")) || [];

    const dashboardStatusMap = savedDashboardData.reduce((acc, item) => {
      acc[item.name] = item.status;
      return acc;
    }, []);

    setDashboardData(dashboardStatusMap);
    setAddOnDashboard(
      dashboardStatusMap[selectedType.value.toLowerCase()] || 0,
    );
  }, []);
  useEffect(() => {
    // Whenever the component mounts or the isAddOnDashboard value changes, you can run this effect
    // For example, you can check if the item is on the dashboard when the component mounts
  }, [isAddOnDashboard]);
  const list = [
    {
      value: "All",
      label: "ALL",
    },
    {
      value: "State",
      label: "State",
    },
    {
      value: "County",
      label: "County",
    },
    {
      value: "City",
      label: "City",
    },
  ];

  const location = useLocation();

  // This could be any custom data or the location data.
  const locationData = location?.state?.search; // assuming data comes from the router state

  useEffect(() => {
    if (locationData) {
      setloader(true);
      // If location data is present, update selectedType accordingly

      setSelectedType(locationData);
    }
  }, [locationData]);

  const handleChange = (type) => {
    setSelectedType(type);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (currentPage > 0) {
      getList();
    }
  }, [currentPage]);

  useEffect(() => {
    if (currentPage > 0 && dashboardData && selectedType?.value) {
      getList();

      const typeKey = selectedType.value.toLowerCase();
      const dashboardCount = dashboardData[typeKey] || 0;

      setAddOnDashboard(dashboardCount);
    }
  }, [selectedType]);
  useEffect(() => {
    if (APICall) getList();
  }, [APICall]);

  const handleWorkTypeSelect = (workType) => {
    setWorkTypeId(workType);
    setCurrentPage(1);
    setResetTrue(false);
    setAPICAll(true);
  };

  const addFav = (project_id, favorite, page_type) => {
    setloader(true);
    const payload = {
      project_id: project_id,
      type:
        selectedType.value.toUpperCase() !== "ALL"
          ? selectedType.value.toUpperCase()
          : page_type.toUpperCase(),
      action: favorite,
      state_id: selectedState?.value,
    };

    AxiosInstance.post(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_ADD_FAVORITE}`,
      payload,
    )
      .then((response) => {
        setloader(false);
        toast.success(response.data?.message);
        // getDirectoryList();
        setList((prevList) =>
          prevList.map((item) =>
            item.project_id === project_id
              ? { ...item, favorites: item.favorites === "0" ? "1" : "0" }
              : item,
          ),
        );
      })
      .catch((error) => {
        toast.error(error?.message);
        setloader(false);
      });
  };

  const addToDashboardApi = (page_type) => {
    setIsLoading(true);
    const payload = {
      page_type: page_type,
    };

    AxiosInstance.post(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_ADD_TO_DASHBOARD}`,
      payload,
    )
      .then((response) => {
        setloader(false);
        toast.success(response.data?.message);

        // Assuming the response contains 'id', 'name', and 'status' as shown in your example:
        const { id, name, status } = response.data.data;

        // Get current data from localStorage
        const existingData =
          JSON.parse(localStorage.getItem("add_to_dashboard")) || [];

        const entryIndex = existingData.findIndex((item) => item.name === name);

        if (entryIndex !== -1) {
          existingData[entryIndex].status = status;
        } else {
          const newEntry = {
            id: id,
            name: name,
            status: status,
          };
          existingData.push(newEntry);
        }

        localStorage.setItem("add_to_dashboard", JSON.stringify(existingData));
        setAddOnDashboard((pre) => !pre);
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error(error?.message);
        setIsLoading(false);
      });
  };

  const getList = async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    setAPICAll(false);
    setloader(true);
    const controller = new AbortController();
    abortControllerRef.current = controller;
    const queryParams = new URLSearchParams({
      page_type:
        typeof selectedType?.value === "string"
          ? selectedType.value.toUpperCase()
          : "STATE",
      page: currentPage,
      limit: pageLimit,
      state_id: selectedState?.value,
      report_id: workTypeId,
      search_text: searchValue,
    });

    const currentTime = new Date().getTime();
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_PROJECT}?currentTime=${currentTime}&${queryParams}`,
        { signal: controller.signal },
      );

      if (response.data?.data) {
        const updatedDesignList = await Promise.all(
          response.data.data.map(async (item) => {
            if (item.worktypes) {
              const worktypeLabels = await getLabelsFromWorktypes(
                item.worktypes,
              );
              return { ...item, worktypeLabels };
            }
            return item;
          }),
        );
        setList(updatedDesignList); // Corrected: Set the updated list
        setPageLimit(response.data?.limit);
        setTotalRecords(response.data?.total_records);
        setTotalPages(response.data?.total_pages);
        setCurrentPage(response.data?.page);
        toast.success(response.data?.message);
      } else {
        setList([]);
        toast.success(response.data?.message);
      }
    } catch (error) {
      if (axios.isCancel(error) || error.code === "ERR_CANCELED") {
        // console.log("Aborted");
        //toast.error(error?.message);
      } else {
        toast.error(error?.message || "Something went wrong");
      }
    } finally {
      setloader(false);
    }
  };
  const handleAPIcall = () => {
    setAPICAll(true);
  };

  const handleModelOpenOptIN = (callid, ccnCallId) => {
    setAPICAll(false);
    setSelectedData(callid);
    setSelectedProjectId(ccnCallId);
    setModelOpenOptIN(true);
  };

  const handleModelOpenSeeRecords = (callid, project_id) => {
    //   setSelectedData(callid);
    setSelectedProjectId(project_id);
    setModelSeeRecords(true);
  };

  const handleModelOpenAdvertiseForHelp = (callId, project_id) => {
    setModelAdvertiseForHelp(true);
    setSelectedProjectId(project_id);
    //  setSelectedData(callId);
  };
  const handleModelOpenPrimeContractorHelpModel = (project_id, callId) => {
    setSelectedProjectId(project_id);
    //    setSelectedData(callId);
    setModelPrimeContractorHelp(true);
  };

  const handleModelClose = () => setModelOpen(false);
  const handleModelCloseViewPlan = () => setModdelOpenViewPlan(false);
  const handleModelCloeseOpenOptIN = () => {
    setModelOpenOptIN(false);
  };
  const handleModelCloeseSeeRecords = () => setModelSeeRecords(false);
  const handleModelCloeseAdvertiseForHelp = () => {
    setModelAdvertiseForHelp(false);
  };

  const handleModelCloesePrimeContractorHelp = () =>
    setModelPrimeContractorHelp(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleReset = () => {
    setResetTrue(true);
    // setSelectedType({
    //   value: "All",
    //   label: "ALL",
    // });
    setCurrentPage(1);
    setSearchValue("");
    setWorkTypeId("");
    setAPICAll(true);
  };
  // Change this handler
  const handleModelOpenDetails = (projectData) => {
    setSelectedData(projectData); // Store the entire object
    setModelDetailsOpen(true);
  };

  const handleModelCloseDetails = () => setModelDetailsOpen(false);
  const handleSearchClick = () => {
    setCurrentPage(1);
    setAPICAll(true);
  };

  const displayTitle = locationData
    ? locationData.label.toUpperCase()
    : selectedType.value.toUpperCase() === "ALL"
      ? "STATE/ COUNTY/ CITY"
      : selectedType.label.toUpperCase();
  return (
    <>
      <Header />
      <div className="bg-primary pt-5 pb-20">
        <div className="container">
          <div className="row">
            <div className="col col-md-auto bg-primary mb-3">
              <p className="text-white point-22">Bid Opportunities</p>
              <h1 className="text-secondary fw-boldest point-42">
                {/* 1. If locationData exists (passed via router state), use it */}
                {locationData ? (
                  locationData?.label.toUpperCase()
                ) : (
                  /* 2. Otherwise, check the dropdown selection */
                  <>
                    {selectedType.value.toUpperCase() === "ALL" ? (
                      <>
                        STATE/
                        <br className="d-block d-md-none" />
                        COUNTY/
                        <br className="d-block d-md-none" />
                        CITY
                      </>
                    ) : (
                      /* 3. Show only the selected type (STATE, COUNTY, or CITY) */
                      selectedType.label.toUpperCase()
                    )}
                  </>
                )}
              </h1>
            </div>
            <div className="col text-end">&nbsp;</div>
          </div>
        </div>
      </div>
      <div className="bg-white py-3">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="card w-100 mt-n20 bg-white rounded-3 shadow-sm mb-5">
                <div className="card-body p-3">
                  <div className="row">
                    <div className="col-12 col-md-auto">
                      <div className="input-group mb-3">
                        <span
                          className="input-group-text text-uppercase text-secondary fw-bold border-0 bg-white rounded-0"
                          id="basic-addon1"
                        >
                          Filter:
                        </span>
                      </div>
                    </div>
                    <div className="col-12 col-md">
                      <div className="input-group mb-3">
                        <div style={{ width: "100%" }}>
                          <Select
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 0,
                            })}
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: "#9FAFCA",
                                borderWidth: "3px",
                                borderTop: "none",
                                borderLeft: "none",
                                borderRight: "none",
                                boxShadow: "none",
                                "&:hover": {
                                  borderColor: "#2684FF",
                                },
                              }),
                              dropdownIndicator: (provided, state) => ({
                                ...provided,
                                color: "#a71e1e",
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                color: "#6c757d",
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isSelected
                                  ? "#9FAFCA"
                                  : "white",
                                color: state.isSelected ? "white" : "black",
                                "&:hover": {
                                  backgroundColor: "#9FAFCA",
                                  color: "white",
                                },
                              }),
                              menu: (provided) => ({
                                ...provided,
                                backgroundColor: "#f8f9fa",
                                zIndex: 9999,
                                borderRadius: 0,
                              }),
                            }}
                            options={list}
                            value={selectedType}
                            onChange={handleChange}
                            reset={resetTrue}
                            placeholder="select any Option"
                            isSearchable
                            isDisabled={locationData ? true : false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className="input-group mb-3">
                        <div style={{ width: "100%" }}>
                          <WorkTypeFilter
                            onSelectWorkType={handleWorkTypeSelect}
                            reset={resetTrue}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className="input-group mb-3">
                        <input
                          type="text"
                          className="form-control fw-bolder text-white bg-secondary rounded-0 border border-1 border-secondary placeholder-white point-18"
                          placeholder="Search"
                          aria-label="Search"
                          aria-describedby="button-addon2"
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                        />
                        <button
                          className="btn btn-primary text-secondary rounded-0 border-0"
                          type="button"
                          id="button-addon2"
                          onClick={handleSearchClick}
                        >
                          <span className="point-20">
                            <img src={searchIcon} alt="icon" />
                          </span>
                        </button>
                      </div>
                    </div>

                    <div className="col-12 col-md-3">
                      <div className="input-group mb-3">
                        <input
                          type="button"
                          className="form-control btn btn-link text-uppercase me-2 text-danger text-start"
                          placeholder="Reset"
                          aria-label="Reset"
                          value="Reset"
                          onClick={() => handleReset()}
                          aria-describedby="basic-addon1"
                        />
                      </div>
                    </div>
                  </div>
                  {false && selectedType &&
                    selectedType.value.toUpperCase() !== "ALL" && (
                      <div className="clearfix">
                        <span className="float-end">
                          <span className="point-12 text-black-50 fw-light d-flex align-items-center">
                            <span className="point-18 text-black-50 fw-light mb-2 me-2">
                              {isLoading ? (
                                <div className="loader">
                                  <img src={loader} alt="loading" />
                                </div>
                              ) : !isAddOnDashboard ? (
                                <i
                                  className="bi bi-star fs-6"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    addToDashboardApi(
                                      selectedType.value.toLowerCase(),
                                    )
                                  }
                                ></i>
                              ) : (
                                <img
                                  src={favoriteImg}
                                  alt="fav"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    addToDashboardApi(
                                      selectedType.value.toLowerCase(),
                                    )
                                  }
                                />
                              )}
                            </span>
                            <span className="text-uppercase fw-bold">
                              Save to Dashboard
                            </span>
                          </span>
                        </span>
                      </div>
                    )}

                  <div className="">
                    <ul className="list-group py-3">
                      {!showloader ? (
                        List.length > 0 ? (
                          List.map((data, i) => (
                            <li
                              key={data.project_id}
                              className="list-group-item  py-3 mb-3 bg-light border border-1 rounded-0 cursor-pointer"
                            >
                              <div className="d-md-flex justify-content-between align-items-start">
                                <div className="me-auto mb-2">
                                  <span className="fw-bold point-22">
                                    {data.project_title}&nbsp;
                                  </span>
                                  <span className="point-22 text-black-50 fw-light mb-2">
                                    {data?.favorites === "0" ? (
                                      <i
                                        className="bi bi-star fs-6"
                                        onClick={() =>
                                          addFav(
                                            data?.project_id,
                                            data?.favorites,
                                            data?.page_type,
                                          )
                                        }
                                      ></i>
                                    ) : (
                                      <img
                                        src={favoriteImg}
                                        alt="fav"
                                        onClick={() =>
                                          addFav(
                                            data?.project_id,
                                            data?.favorites,
                                            data?.page_type,
                                          )
                                        }
                                      />
                                    )}
                                  </span>
                                </div>
                                <div className="mb-2">
                                  <button
                                    type="button"
                                    className="btn btn-secondary text-primary rounded-pill text-uppercase py-1 px-3 fw-semibold point-16"
                                    onClick={() => handleModelOpenDetails(data)} // Pass the whole 'data' item
                                  >
                                    Details
                                  </button>
                                </div>
                              </div>
                              <p className="lh-lg">
                                {data.date_entered &&
                                  data.estimated_end_date && (
                                    <>
                                      <span className="fw-bold">
                                        Date Posted:
                                      </span>{" "}
                                      {getFormattedDate(data.date_entered)}
                                      <span className="text-danger fw-bolder">
                                        &nbsp;|&nbsp;
                                      </span>
                                      <span className="fw-bold">Date Due:</span>{" "}
                                      {getFormattedDate(
                                        data.estimated_end_date,
                                      )}
                                      <span className="text-danger fw-bolder">
                                        &nbsp;|&nbsp;
                                      </span>
                                      <span className="fw-bold">
                                        Time to the Bid Open :{" "}
                                      </span>{" "}
                                      ({getTimeAgo(data.date_entered)})
                                      <br />
                                    </>
                                  )}
                                {/* {data?.Ldescription} <br /> */}
                                {!data?.flag_optin ? (
                                  <span
                                    className="fw-bold text-decoration-underline text-secondary view-link"
                                    onClick={() =>
                                      handleModelOpenOptIN(
                                        data?.callid,
                                        data?.project_id,
                                      )
                                    }
                                  >
                                    Subs/Suppliers: Opt In
                                  </span>
                                ) : (
                                  <span className="fw-bold text-secondary">
                                    Subs/Suppliers: Opt In
                                  </span>
                                )}
                                <span className="text-danger fw-bolder d-none d-md-inline-block">
                                  &nbsp;|&nbsp;
                                </span>
                                <br className="d-block d-md-none" />
                                <span
                                  className="text-decoration-underline text-secondary view-link"
                                  onClick={() =>
                                    handleModelOpenSeeRecords(
                                      data?.callid,
                                      data?.project_id,
                                    )
                                  }
                                >
                                  See{" "}
                                  <span className="fw-bold">
                                    {data?.count_optin}
                                  </span>{" "}
                                  Opt-in Records
                                </span>
                                <span className="text-danger fw-bolder d-none d-md-inline-block">
                                  &nbsp;|&nbsp;
                                </span>
                                <br className="d-block d-md-none" />
                                {!data?.flag_prime_advertise ? (
                                  <span
                                    className="fw-bold text-decoration-underline text-secondary view-link"
                                    onClick={() =>
                                      handleModelOpenAdvertiseForHelp(
                                        data?.callid,
                                        data?.project_id,
                                      )
                                    }
                                  >
                                    &nbsp;Primes: Advertise for help
                                  </span>
                                ) : (
                                  <span className="fw-bold text-secondary text-secondary ">
                                    &nbsp;Primes: Advertise for help
                                  </span>
                                )}
                                <span className="text-danger fw-bolder d-none d-md-inline-block">
                                  &nbsp;|&nbsp;
                                </span>
                                <br className="d-block d-md-none" />
                                <span className="fw-bold ">
                                  {data?.count_prime_advertise || 0}
                                </span>{" "}
                                <span
                                  className="text-decoration-underline text-secondary view-link"
                                  onClick={() =>
                                    handleModelOpenPrimeContractorHelpModel(
                                      data?.project_id,
                                      data?.callid,
                                    )
                                  }
                                >
                                  Prime contractors looking for help
                                </span>
                              </p>
                            </li>
                          ))
                        ) : (
                          <div className="d-md-flex justify-content-center">
                            No Data Found.
                          </div>
                        )
                      ) : (
                        <div className="loader">
                          <img src={loader} alt="loading" />
                        </div>
                      )}
                    </ul>
                  </div>

                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    pageLimit={pageLimit}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modelOpenOptIN && (
        <OptInModel
          open={modelOpenOptIN}
          project_id={selectedProjectId}
          // callId={selectedData}
          handleClose={handleModelCloeseOpenOptIN}
          handleAPIcall={handleAPIcall}
          type="PROJECT"
          endPoint={process.env.REACT_APP_GET_ADD_PROJECT_OPTIN}
        />
      )}

      {modelOpenViewPlan && (
        <ViewPlanHolderModel
          open={modelOpenViewPlan}
          handleClose={handleModelCloseViewPlan}
          callId={selectedData}
        />
      )}
      {modelSeeRecords && (
        <SeeRecordsModel
          open={modelSeeRecords}
          project_id={selectedProjectId}
          callId={selectedData}
          handleClose={handleModelCloeseSeeRecords}
          endPoint={process.env.REACT_APP_GET_GET_PROJECT_OPTIN}
          type="PROJECT"
        />
      )}
      {modelAdvertiseForHelp && (
        <AdvertiseForHelpModel
          open={modelAdvertiseForHelp}
          handleClose={handleModelCloeseAdvertiseForHelp}
          callId={selectedData}
          project_id={selectedProjectId}
          handleAPIcall={handleAPIcall}
          endPoint={process.env.REACT_APP_GET_ADD_ADVERTISE_FOR_HELP_PROJECT}
          type="PROJECT"
        />
      )}
      {PrimeContractorHelp && (
        <PrimeContractorHelpModel
          open={PrimeContractorHelp}
          callId={selectedData}
          project_id={selectedProjectId}
          handleClose={handleModelCloesePrimeContractorHelp}
          endPoint={process.env.REACT_APP_GET_PRIME_ADVERTISE_PROJECT}
          type="PROJECT"
        />
      )}
      {modelDetailsOpen && (
        <ProjectDetailsModel
          open={modelDetailsOpen}
          data={selectedData} // This is now the full object
          handleClose={handleModelCloseDetails}
        />
      )}
      <Footer />
    </>
  );
}
